<template>
  <div>
    <div v-if="this.isSquare" class="ma-auto" :style="{ maxWidth: '250px' }">
      <BtnLayout :item="item" />
    </div>
    <BtnLayout v-else :item="item" />
  </div>
</template>

<script>
import BtnLayout from './BtnLayout'

export default {
  name: 'BtnXBig',
  components: { BtnLayout },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSquare () {
      return this.item.itemableAttributes.type === 'square'
    }
  }
}
</script>
